import React from 'react';
import { NavLink } from 'react-router-dom';

const AddCategoryCrumb = () => <NavLink to="/admin/categories/add">Add Category</NavLink>;

export default AddCategoryCrumb;
